import { effect, ElementRef, inject, Injectable, TemplateRef } from '@angular/core';
import { BreakpointService } from '@big-direkt/utils/shared';
import { NgOverlayContainerConfiguration, NgOverlayContainerService, NgPopoverRef } from 'ng-overlay-container';

@Injectable({
    providedIn: 'root',
})
export class PopoverService {
    private readonly breakpointService = inject(BreakpointService);
    private readonly overlayContainerService = inject(NgOverlayContainerService);

    public popoverRef?: NgPopoverRef;

    public constructor() {
        effect(() => {
            if (!this.breakpointService.isTablet() && !this.breakpointService.isDesktop()) {
                this.closeCurrent();
            }
        });
    }

    public open(content: TemplateRef<ElementRef>, origin: HTMLElement, params?: Partial<NgOverlayContainerConfiguration>): void {
        this.popoverRef = this.overlayContainerService.open({
            content,
            origin,
            configuration: {
                panelClass: 'overflow-hidden',
                width: '300px',
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top',
                offsetY: 0,
                isResizable: false,
                ...params,
            },
        });
    }

    public closeCurrent(): void {
        this.popoverRef?.close();
    }
}
